import { FC } from 'react'
import { Typography, Button } from '@material-tailwind/react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

interface FinalizeUserTitleProps {
  userType?: string
}

const FinalizeUserTitle: FC<FinalizeUserTitleProps> = ({ userType }) => {
  const { t } = useTranslation()

  return (
    <div className={`${userType ? 'mb-0' : 'mb-8'} flex flex-col justify-center items-center`}>
      <Typography className="mt-4" variant="h1">
        {t('finalize.title')}
      </Typography>

      {userType && <hr className="w-full md:w-1/4 my-6 bg-accent border-accent" />}

      {userType === 'indiegogo' && <Typography variant="h3">{t('finalize.indiegogoSupporter')}</Typography>}

      {userType === 'bch-owner' && <Typography variant="h3">{t('finalize.bchOwner')}</Typography>}

      {userType === 'profile-only' && (
        <>
          <Typography variant="h3" className="mb-2">
            {t('finalize.profileOnly')}
          </Typography>
          <Typography variant="paragraph" className="font-bold">
            {t('finalize.platformBestWithBch')}
          </Typography>
          <Typography variant="paragraph">{t('finalize.sureNoBch')}</Typography>
          <Link
            className="mt-2"
            to="https://www.indiegogo.com/projects/agami-everywhere-immersive-sound"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Button size="sm">{t('auth.buyNow')}</Button>
          </Link>
        </>
      )}
    </div>
  )
}

export default FinalizeUserTitle
